import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63738f1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen relative flex items-baseline lg:items-center justify-center bg-gray-100 pt-40 lg:pt-12 sm:px-8 py-12 px-4" }
const _hoisted_2 = { class: "hidden lg:block" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "login-header",
  class: "mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
}, " Sign in to your account ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "remember",
  value: "true"
}, null, -1))
const _hoisted_6 = { class: "rounded-md shadow-sm" }
const _hoisted_7 = { class: "-mt-px" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 flex text-red-400"
}
const _hoisted_9 = { class: "mt-6 flex items-center justify-between" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "remember_me",
  class: "ml-2 block text-sm leading-5 text-gray-900"
}, "Remember me", -1))
const _hoisted_12 = { class: "text-sm leading-5" }
const _hoisted_13 = { class: "mt-6 flex justify-center" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "absolute left-0 inset-y-0 flex items-center pl-3"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "font-semibold text-white lg:text-current"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ButtonLoader = _resolveComponent("ButtonLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["max-w-md w-full rounded px-5 sm:px-10 border bg-white relative z-10", _ctx.newMobileScreens ? 'pt-5 pb-8' : 'py-16 shadow'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          id: "login-brand-logo",
          class: "brand-logo mx-auto h-12 lg:h-20 md:h-16 w-auto",
          src: _ctx.brandLogoUrl
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", {
        class: "flex items-center justify-center w-16 h-16 rounded-full border-2 border-white lg:hidden absolute top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2 fallback-theme-background",
        style: _normalizeStyle({ 'background-color': _ctx.getMobileTheme().secondaryHexCode })
      }, [
        _createVNode(_component_BaseIcon, {
          name: "scholar",
          hwClass: "w-8 h-8 text-white"
        })
      ], 4),
      _createElementVNode("form", {
        id: "login-form",
        class: "mt-8",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              "aria-label": "Email address",
              name: "email",
              type: "email",
              required: "",
              class: "appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5",
              placeholder: "Email address"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              "aria-label": "Password",
              name: "password",
              type: "password",
              required: "",
              class: "appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5",
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        (_ctx.errorMsg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMsg), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
              id: "remember_me",
              type: "checkbox",
              class: "form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
            }, null, 512), [
              [_vModelCheckbox, _ctx.rememberMe]
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              id: "forgot-password",
              to: { name: 'recovery' },
              class: "font-semibold text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Forgot your password?")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            id: "login-button",
            disabled: _ctx.loader,
            type: "submit",
            class: _normalizeClass([[
              _ctx.loader ? 'cursor-not-allowed' : '',
              _ctx.newMobileScreens
                ? `w-1/3 px-5 py-2 ${_ctx.getMobileTheme().primary}`
                : 'w-1/2 py-2 px-4 lg:bg-blue-600 lg:hover:bg-blue-500 lg:focus:border-blue-700 active:bg-blue-700 fallback-theme-background',
            ], "group relative flex justify-center border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out lg:w-full"])
          }, [
            (_ctx.loader)
              ? (_openBlock(), _createBlock(_component_ButtonLoader, { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.newMobileScreens)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createVNode(_component_BaseIcon, {
                          name: "lockfilled",
                          hwClass: "w-3 h-3"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Sign in ")
                ], 64))
          ], 10, _hoisted_14)
        ])
      ], 32)
    ], 2),
    _createElementVNode("div", {
      class: "flex items-center justify-center pb-16 w-full h-56 absolute top-0 lg:hidden fallback-theme-background",
      style: _normalizeStyle({ 'background-color': _ctx.getMobileTheme().secondaryHexCode })
    }, [
      (_ctx.brandLogoUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "brand-logo h-10 w-auto sm:h-10",
            src: _ctx.replaceBucketUrlWithCdnUrl(_ctx.brandLogoUrl),
            alt: "Logo"
          }, null, 8, _hoisted_16))
        : (_openBlock(), _createElementBlock("p", _hoisted_17, "Your Logo"))
    ], 4)
  ]))
}